var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXcoridLogoNegative(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 124,
    height: 21,
    viewBox: "0 0 124 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_139",
    "data-name": "Ret\\xE2ngulo 139",
    width: 124,
    height: 21
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "xcorid-logo-negative",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    strokeWidth: 2,
    stroke: "#000000",
    fill: "#000000",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_138",
    "data-name": "Rectangle 138",
    width: 33.608,
    height: 21.109,
    transform: "translate(90.376 -0.024)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_592",
    "data-name": "Group 592",
    transform: "translate(2.167 2.954)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160",
    "data-name": "Group 160",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "xcorid",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_212",
    "data-name": "Path 212",
    d: "M119.363-91.478a4.414,4.414,0,0,0-1.713,1.083l-.65.709v10.675l.748.748c1.32,1.32,1.95,1.4,9.631,1.339,6.657-.059,6.657-.059,7.622-.551,1.536-.768,1.773-1.26,1.851-3.565l.079-1.95h-4.963v2.954H121.924V-88.7h10.044v2.816l.985-.118a6.651,6.651,0,0,0,3.407-1.457c1.1-1.083.532-2.994-1.182-3.821-.926-.473-1.024-.473-7.839-.512C120.959-91.852,120.368-91.813,119.363-91.478Z",
    transform: "translate(-94.095 91.872)",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_213",
    "data-name": "Path 213",
    d: "M229.875-91.555a3.562,3.562,0,0,0-2.5,1.832c-.315.709-.374,1.339-.374,5.436,0,5.554.079,5.849,1.792,6.795l1.064.591h14.377l.965-.492c1.812-.906,1.792-.827,1.792-6.893s.02-5.987-1.792-6.893l-.965-.492-6.795-.039C233.7-91.732,230.289-91.653,229.875-91.555Zm12.29,7.267v4.333H231.924V-88.62h10.241Z",
    transform: "translate(-182.431 91.791)",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_214",
    "data-name": "Path 214",
    d: "M338-84.577v7.523l1.418-.138a3.647,3.647,0,0,0,2.994-1.359c.394-.532.414-.827.473-5.475l.059-4.9h10.222v2.757H349.3a23.129,23.129,0,0,0-3.781.158c.039.079,1.6,2.127,3.486,4.53l3.447,4.372h2.915a20.927,20.927,0,0,0,2.915-.1c0-.059-1.024-1.359-2.285-2.9l-2.285-2.816,1.064-.217A4.551,4.551,0,0,0,357.4-84.4c.335-.374.394-.768.453-2.935.059-2.954-.158-3.506-1.694-4.215-.906-.414-1.162-.433-9.532-.492L338-92.1Z",
    transform: "translate(-271.569 92.1)",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_217",
    "data-name": "Path 217",
    d: "M1.567-90.252c.473.414,2.107,1.851,3.624,3.151l2.757,2.4h1.91a5.693,5.693,0,0,0,1.93-.158c-.02-.079-.886-1.477-1.95-3.092L7.928-90.9,4.3-90.961.7-91Z",
    transform: "translate(-0.7 91.217)",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_218",
    "data-name": "Path 218",
    d: "M60.113-88.065c-1.024,1.615-1.891,3.013-1.93,3.151-.059.158.512.217,1.871.217h1.93l3.053-2.678c1.674-1.457,3.269-2.875,3.545-3.151L69.074-91H65.529l-3.545.02Z",
    transform: "translate(-46.859 91.217)",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_219",
    "data-name": "Path 219",
    d: "M5.19-44.6c-1.516,1.3-3.151,2.738-3.624,3.151L.7-40.7l3.6-.039L7.928-40.8l1.91-2.954c1.064-1.635,1.93-3.013,1.95-3.112A6.774,6.774,0,0,0,9.858-47H7.948Z",
    transform: "translate(-0.7 55.882)",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_220",
    "data-name": "Path 220",
    d: "M58.183-46.783c.039.138.906,1.536,1.93,3.151l1.871,2.915,3.545.02h3.545l-.492-.473c-.276-.276-1.871-1.694-3.545-3.151L61.984-47h-1.93C58.7-47,58.124-46.941,58.183-46.783Z",
    transform: "translate(-46.859 55.882)",
    fill: "#000000"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_221",
    "data-name": "Path 221",
    d: "M475-85.717c0,6.164,0,6.283.453,6.933a4.788,4.788,0,0,0,3.368,1.694l1.1.118V-92H475Z",
    transform: "translate(-379.421 94.974)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_222",
    "data-name": "Path 222",
    d: "M509-84.6v7.5l8.626-.059,8.607-.059.965-.492c1.812-.906,1.792-.827,1.792-6.893s.02-5.987-1.792-6.893l-.965-.492-8.607-.059L509-92.1Zm15.165,0v4.333H514.121v-8.666h10.044Z",
    transform: "translate(-406.725 95.054)",
    fill: "#ffffff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXcoridLogoNegative);
export default __webpack_public_path__ + "static/media/xcorid-logo-negative.d8b494c1a8f9c286757f1da0abd17dcb.svg";
export { ForwardRef as ReactComponent };